import * as React from "react";
import { usePopupContext } from "src/hooks/usePopup";
import { InputClause, Clauses, UseQuestionInputClauses } from "./definitions";
import { DateRangeClause } from "./DateRangeClause";
import { GroupByClause } from "./GroupByClause";
import { MeasureByClause } from "./MeasureByClause";
import { SearchTermClause } from "./SearchTermClause";
import { SelectClause } from "./SelectClause";
import { FilterConditionClause } from "./FilterConditionClause";
import { CompareWithClause } from "./CompareWithClause";
import { FormulaClause } from "./FormulaClause";
import { HavingClause } from "./HavingClause";

export function ClauseSwitch({
  clause,
  value,
  updateClause,
  removeClause,
  sameAsLast,
}: {
  clause: InputClause;
  sameAsLast?: boolean;
} & Pick<UseQuestionInputClauses, "value" | "updateClause" | "removeClause">) {
  const { close } = usePopupContext();
  const handleUpdate = React.useCallback(
    (clause_: InputClause) => {
      updateClause({
        ...clause_,
        status: "ready",
      });
      close();
    },
    [updateClause, close]
  );
  const methods = {
    removeClause: removeClause,
    updateClause: handleUpdate,
    sameAsLast: Boolean(sameAsLast),
  };
  switch (clause.type) {
    case Clauses.DATE_RANGE: {
      return <DateRangeClause {...methods} clause={clause} />;
    }
    case Clauses.FILTER_CONDITION: {
      return (
        <FilterConditionClause {...methods} clause={clause} value={value} />
      );
    }
    case Clauses.GROUP_BY: {
      return <GroupByClause {...methods} clause={clause} value={value} />;
    }
    case Clauses.MEASURE_BY: {
      return <MeasureByClause {...methods} clause={clause} value={value} />;
    }
    case Clauses.FORMULA: {
      return <FormulaClause {...methods} clause={clause} value={value} />;
    }
    case Clauses.HAVING: {
      return <HavingClause {...methods} clause={clause} value={value} />;
    }
    case Clauses.SEARCH_TERM: {
      return <SearchTermClause {...methods} clause={clause} />;
    }
    case Clauses.SELECT: {
      return <SelectClause {...methods} clause={clause} value={value} />;
    }
    case Clauses.COMPARE_WITH: {
      return <CompareWithClause {...methods} clause={clause} value={value} />;
    }
  }
}
